import {AfterViewInit, Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DomSanitizer} from "@angular/platform-browser";
import Cropper from 'cropperjs';
import {BicButtonComponent, BicPopupComponent} from "@buildinginformationcloud/bic-ui-components";

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BicButtonComponent,
    BicPopupComponent
  ]
})
export class ImageCropperComponent implements OnInit, AfterViewInit{
  dialogRef = inject<MatDialogRef<ImageCropperComponent>>(MatDialogRef);
  image = inject(MAT_DIALOG_DATA);
  private sanitizer = inject(DomSanitizer);


  cropper! : Cropper;
  sanitizedUrl: any;
  optimalHeight = 500;
  scalingFactor = 0.8;

  ngOnInit(): void {
    this.sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl(this.image);
  }

  ngAfterViewInit() {
    this.initCropper();
  }

  initCropper() {
    const image = document.getElementById('image') as HTMLImageElement;

    this.cropper = new Cropper(image, {
      aspectRatio: 1,
      viewMode: 1,
      guides: false,

    });
  }


  getRoundedCanvas(sourceCanvas: any) {
    var canvas = document.createElement('canvas');
    var context: any = canvas.getContext('2d');
    var width = sourceCanvas.width;
    var height = sourceCanvas.height;

    canvas.width = width;
    canvas.height = height;
    context.imageSmoothingEnabled = true;
    context.drawImage(sourceCanvas, 0, 0, width, height);
    context.globalCompositeOperation = 'destination-in';
    context.beginPath();
    context.arc(
      width / 2,
      height / 2,
      Math.min(width, height) / 2,
      0,
      2 * Math.PI,
      true
    );
    context.fill();
    return canvas;

  }

  close(){
    this.dialogRef.close(null);
  }


  crop() {
    const croppedCanvas = this.cropper.getCroppedCanvas();
    const roundedCanvas = this.getRoundedCanvas(croppedCanvas);

    let roundedImage = document.createElement('img');

    if (roundedImage) {
      this.dialogRef.close(roundedCanvas.toDataURL());
    } else {
      return this.dialogRef.close(null);
    }
  }

  reset(){
    this.cropper.clear();
    this.cropper.crop();
  }

}
